export default __webpack_public_path__ + "static/pinterest-icon-a73f5091bfaba0864d8ae0d95df76da5.png";